import PropTypes from 'prop-types';
import { TextareaAutosize } from '@material-ui/core';

const ChatbotTextArea = ({
  inputText,
  setInputText,
  handleClickOnInputField,
  PLACEHOLDER_TEXT,
  handleSubmitQuery,
}) => (
  <TextareaAutosize
    value={inputText}
    onClick={handleClickOnInputField}
    onChange={(event) => setInputText(event.target.value)}
    placeholder={PLACEHOLDER_TEXT}
    className="border border-gray-500 border-opacity-25 sm:px-6 sm:py-3 px-4 py-2 rounded-2xl placeholder-gray-700 w-full focus:outline-none resize-none"
    onKeyDown={(event) => {
      if (event.key === 'Enter' && !event.shiftKey && inputText.trim() !== '') {
        handleSubmitQuery(event);
      }
    }}
    rowsMin={1}
  />
);

ChatbotTextArea.propTypes = {
  inputText: PropTypes.string.isRequired,
  setInputText: PropTypes.func.isRequired,
  handleClickOnInputField: PropTypes.func.isRequired,
  PLACEHOLDER_TEXT: PropTypes.string.isRequired,
  handleSubmitQuery: PropTypes.func.isRequired,
};

export default ChatbotTextArea;
